import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from "../../../../../shared/model";
import { bytesToKilobytes, parseFileName } from "../../../ui/FileView/utils";
import { MessageStatus } from "../../../../../shared/api";
import { getMessageFile } from "../../../../../shared/lib";
import { AttachLabel } from "../../../../../shared/config";
import { downloadFile } from "../../utils";
import { ymPushClickAttachView } from "../../../../../shared/analytics";
import { selectChatCofig } from "../../../../settings/model";
import { getFileThunk } from "../../../model/redux";

// Todo: доработать оптимизацию
export var useFileDoc = function useFileDoc(message) {
  var dispatch = useAppDispatch();
  var _useAppSelector = useAppSelector(selectChatCofig),
    zoneType = _useAppSelector.authZoneConfig.zoneType;
  var _getMessageFile = getMessageFile(message),
    name = _getMessageFile.name,
    size = _getMessageFile.size;
  var fileName = message.message.name || name;
  var fileSize = bytesToKilobytes(message.message.size || size);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDownloading = _useState2[0],
    setDownloading = _useState2[1];
  var isDownloadStep = !message.message.fileUrl;
  var isLoading = message.messageStatus === MessageStatus.sent || isDownloading;
  var configDownload = message.message.fileUrl && fileName ? {
    download: name,
    href: message.message.fileUrl
  } : {};
  var handleCLick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _getMessageFile2, fileUrl, resultAction;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            ymPushClickAttachView(AttachLabel.FIlE, zoneType);
            if (!message.message.fileUrl) {
              _context.next = 4;
              break;
            }
            downloadFile(message.message.fileUrl, fileName);
            return _context.abrupt("return");
          case 4:
            _getMessageFile2 = getMessageFile(message), fileUrl = _getMessageFile2.fileUrl;
            if (!(fileUrl && !message.message.fileUrl)) {
              _context.next = 12;
              break;
            }
            setDownloading(true);
            _context.next = 9;
            return dispatch(getFileThunk({
              url: fileUrl,
              message: message
            }));
          case 9:
            resultAction = _context.sent;
            if (getFileThunk.rejected.match(resultAction) || getFileThunk.fulfilled.match(resultAction)) {
              setDownloading(false);
            }
            if (getFileThunk.fulfilled.match(resultAction)) {
              downloadFile(resultAction.payload, fileName);
            }
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCLick() {
      return _ref.apply(this, arguments);
    };
  }();
  return _objectSpread(_objectSpread({}, parseFileName(fileName)), {}, {
    size: fileSize,
    isLoading: isLoading,
    handleCLick: handleCLick,
    configDownload: configDownload,
    isDownloadStep: isDownloadStep
  });
};